"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var auth0_react_1 = require("@auth0/auth0-react");
var antd_1 = require("antd");
var icons_1 = require("@ant-design/icons");
var actions_1 = require("../../modules/assets/actions");
var utils_1 = require("../../utils");
var pages_1 = require("../../hooks/pages");
var hooks_1 = require("../../hooks");
var styles = {
    footerLabel: { fontWeight: "bold" },
};
var AssetListView = react_1.default.memo(function () {
    var navigate = (0, react_router_dom_1.useNavigate)();
    var dispatch = (0, hooks_1.useAppDispatch)();
    var getAccessTokenSilently = (0, auth0_react_1.useAuth0)().getAccessTokenSilently;
    var assetsInitialFetch = (0, hooks_1.useAppSelector)(function (state) { return state.assets.initialFetchDone; });
    var assetsFetching = (0, hooks_1.useAppSelector)(function (state) { return state.assets.isFetching; });
    var assets = (0, hooks_1.useAppSelector)(function (state) { return state.assets.items; });
    var assetTypes = (0, hooks_1.useAppSelector)(function (state) { return state.assetTypes.items; });
    var _a = (0, react_1.useState)(null), delAsset = _a[0], setDelAsset = _a[1];
    var closeDelModal = (0, react_1.useCallback)(function () { return setDelAsset(null); }, []);
    var onDelete = (0, react_1.useCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
        var token, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!delAsset)
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, getAccessTokenSilently(utils_1.ACCESS_TOKEN_MANAGE)];
                case 2:
                    token = _a.sent();
                    return [4 /*yield*/, dispatch((0, actions_1.deleteAsset)(delAsset.id, token))];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    e_1 = _a.sent();
                    console.error(e_1);
                    return [3 /*break*/, 5];
                case 5:
                    closeDelModal();
                    return [2 /*return*/];
            }
        });
    }); }, [dispatch, getAccessTokenSilently, delAsset]);
    // noinspection JSUnusedGlobalSymbols,JSUnresolvedVariable
    var columns = (0, react_1.useMemo)(function () { return [
        {
            title: "File name",
            dataIndex: "file_name",
            shouldCellUpdate: function (r, pr) { return r.id !== pr.id || r.file_name !== pr.file_name; },
            render: function (fileName, asset) { return react_1.default.createElement(react_router_dom_1.Link, { to: "/assets/detail/".concat(asset.id) }, fileName); },
        },
        {
            title: "Type",
            dataIndex: "asset_type",
            filters: assetTypes.map(function (t) { return ({ text: t, value: t }); }),
            onFilter: function (value, record) { return record.asset_type === value; },
        },
        {
            title: "Size",
            dataIndex: "file_size",
            sorter: function (a, b) { return a.file_size - b.file_size; },
            shouldCellUpdate: function (r, pr) { return r.file_size !== pr.file_size; },
            render: function (fileSize) { return react_1.default.createElement("span", null,
                (fileSize / 1000).toFixed(0),
                "\u00A0KB"); },
        },
        // TODO: Link this to modal
        {
            title: "Times used (total / enabled)",
            width: 210,
            shouldCellUpdate: function (r, pr) {
                return (r.times_used_by_all !== pr.times_used_by_all) ||
                    (r.times_used_by_enabled !== pr.times_used_by_enabled);
            },
            render: function (asset) { return "".concat(asset.times_used_by_all, " / ").concat(asset.times_used_by_enabled); },
        },
        {
            title: "Actions",
            key: "actions",
            shouldCellUpdate: function (r, pr) { return r.id !== pr.id || r.enabled !== pr.enabled; },
            render: function (asset) { return (react_1.default.createElement(antd_1.Space, { size: "small" },
                react_1.default.createElement(antd_1.Button, { icon: react_1.default.createElement(icons_1.EyeOutlined, null), onClick: function () { return navigate("/assets/detail/".concat(asset.id)); } }, "View"),
                react_1.default.createElement(antd_1.Button, { icon: react_1.default.createElement(icons_1.DeleteOutlined, null), disabled: asset.times_used_by_all !== 0, danger: true, onClick: function () { return setDelAsset(asset); } }, "Delete"))); }
        },
    ]; }, [navigate]);
    var extra = (0, react_1.useMemo)(function () { return [
        react_1.default.createElement(antd_1.Button, { key: "add", type: "primary", icon: react_1.default.createElement(icons_1.PlusOutlined, null), onClick: function () { return navigate("/assets/add"); } }, "Add New"),
    ]; }, [navigate]);
    // noinspection JSUnresolvedVariable
    var totalUsedAssetSize = (0, react_1.useMemo)(function () { return assets
        .filter(function (a) { return a.times_used_by_enabled > 0; })
        .reduce((function (acc, asset) { return acc + asset.file_size; }), 0); }, [assets]);
    var footer = (0, react_1.useCallback)(function () { return react_1.default.createElement("span", null,
        react_1.default.createElement("span", { style: styles.footerLabel }, "Total Used Asset Size:"),
        "\u00A0",
        (!assetsInitialFetch && assetsFetching)
            ? "\u2013"
            : "".concat((totalUsedAssetSize / 1000).toFixed(0), " KB")); }, [assetsInitialFetch, assetsFetching, totalUsedAssetSize]);
    var pagination = (0, pages_1.useUrlPagination)();
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(antd_1.Modal, { title: "Delete asset: ".concat(delAsset === null || delAsset === void 0 ? void 0 : delAsset.file_name), open: !!delAsset, onCancel: closeDelModal, footer: react_1.default.createElement(antd_1.Space, null,
                react_1.default.createElement(antd_1.Button, { type: "primary", danger: true, icon: react_1.default.createElement(icons_1.DeleteOutlined, null), onClick: onDelete }, "Delete"),
                react_1.default.createElement(antd_1.Button, { onClick: closeDelModal }, "Cancel")) },
            "Are you sure you wish to delete the asset \u201C", delAsset === null || delAsset === void 0 ? void 0 :
            delAsset.file_name,
            "\u201D?"),
        react_1.default.createElement(antd_1.PageHeader, { ghost: false, title: "Assets", subTitle: "View and edit app assets (images, videos, and audio)", extra: extra },
            react_1.default.createElement(antd_1.Table, { bordered: true, size: "small", loading: !assetsInitialFetch && assetsFetching, columns: columns, dataSource: assets, footer: footer, rowKey: "id", pagination: pagination })));
});
exports.default = AssetListView;
